// extracted by mini-css-extract-plugin
export default {"button":"button-dQdc","group":"group-P0oQ"};